type Klass<T> = new (...args: any[]) => T

export const getSingletonStore = <T>(Store: Klass<T>, args?: any): (() => T) => {
  let store: T | null = null
  return function () {
    if (store === null) {
      store = new Store(args)
    }
    return store as any
  }
}

export const filterEmptyObject = (obj: { [key: string]: any }) => {
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object') {
      filterEmptyObject(obj[key])
    }
    if (typeof obj[key] !== 'number' && !obj[key]) {
      delete obj[key]
    }
  })
  return obj
}

export enum NETS {
  DIOXIDE = 'Dioxide',
  BITREXE = 'BitReXe',
}

export const NET_ENDPOINT = {
  [String(NETS.DIOXIDE)]: {
    api: process.env.NEXT_PUBLIC_API_HOST,
    scan: process.env.NEXT_PUBLIC_DIOSCAN_DOMAIN,
  },
  [String(NETS.BITREXE)]: {
    api: process.env.NEXT_PUBLIC_BITREXE_API_HOST,
    scan: process.env.NEXT_PUBLIC_BITREXE_DIOSCAN_DOMAIN,
  },
}

export const DEFAULT = {
  [String(NETS.DIOXIDE)]: {
    SYMBOL: 'DIO',
    DECIMAL: 8,
  },
  [String(NETS.BITREXE)]: {
    SYMBOL: 'RXBTC',
    DECIMAL: 17,
  },
}

export const getDefaultToken = (): typeof DEFAULT[string] | any => {
  if (typeof window === 'undefined' || !window.net) {
    return {}
  }
  return DEFAULT[window.net]
}
export const getDefaultChain = (): typeof DEFAULT[string] | any => {
  if (typeof window === 'undefined' || !window.net) {
    return {}
  }
  return window.net
}
